import React, { useEffect } from 'react';
import { Drawer } from '@dsg-tech/homefield-react';
import { StoreIdentifierName } from 'types';
import { useAppSelector } from 'store/store';
import {
  searchDataSelector,
  searchInputSelector,
  showSaytDrawerSelector,
} from 'store/selectors/saytSelector';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import SearchBar from '../SearchBar';
import SAYTSuggestions from '../SAYTSuggestions/SAYTSuggestions';
import SearchUtils from '../SearchUtils';
import './SAYTModalMobile.scss';

type SAYTModalMobileProps = {
  storeIdentifierName: StoreIdentifierName;
  thumbnailApi: string;
};

const SAYTModalMobile = ({ storeIdentifierName, thumbnailApi }: SAYTModalMobileProps) => {
  const showSaytDrawer = useAppSelector(showSaytDrawerSelector);
  const searchInput = useAppSelector(searchInputSelector);
  const searchData = useAppSelector(searchDataSelector);
  const { updateSearchTermSAYT, submitSearch } = SearchUtils(storeIdentifierName);

  useEffect(() => {
    if (showSaytDrawer) {
      const modal = document.querySelector('.sayt-modal-mobile') as HTMLElement;
      const searchBar = modal?.querySelector('#searchInput') as HTMLInputElement;
      searchBar?.focus();
    }
  }, [showSaytDrawer]);

  return (
    <Drawer open={showSaytDrawer} closable={false} className="sayt-modal-mobile" size="large">
      <>
        <ErrorBoundaryWithLogger componentId="SAYTModalMobile-SearchBar">
          <SearchBar
            storeIdentifierName={storeIdentifierName}
            thumbnailApi={thumbnailApi}
            mobileDrawer
          />
        </ErrorBoundaryWithLogger>
        {searchData?.suggestions && searchInput && searchInput.length > 2 && (
          <ErrorBoundaryWithLogger componentId="SAYTModalMobile-SAYTSuggestions">
            <SAYTSuggestions
              storeIdentifierName={storeIdentifierName}
              thumbnailApi={thumbnailApi}
              searchData={searchData}
              submitSearch={submitSearch}
              searchTerm={searchInput}
              updateSearchTermSAYT={updateSearchTermSAYT}
              mobileDrawer
            />
          </ErrorBoundaryWithLogger>
        )}
      </>
    </Drawer>
  );
};

export default SAYTModalMobile;
